
import { createContext } from "react";

import { DocumentEvent } from "@/apis/dtos";
import useGetDocumentVerificationEvents from "@/hooks/data/useGetDocumentVerificationEvents";

export interface IDocumentVerificationEventContext extends Omit<ReturnType<typeof useGetDocumentVerificationEvents>, 'data' | 'total' | 'offset'> {
    data?: DocumentEvent[];
}

export const DocumentVerificationEventContext = createContext<IDocumentVerificationEventContext>({
    data: undefined,
    loading: false,
    validating: false,
    error: undefined,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined }
})